exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-subscriber[data-v-113fc619]{margin:0}.theatre-title[data-v-113fc619]{position:absolute;margin:0;right:50px}.theatre-container .back-button[data-v-113fc619]{top:-5px;left:-20px}.theatre-container .selected-seats[data-v-113fc619]{top:60px;right:16px}.theatre-container .selected-seats .md-list[data-v-113fc619]{max-height:calc(100vh - 400px)}.seat-details[data-v-113fc619]{max-width:1200px;width:100%;overflow-y:scroll}.seat-details .seat-list[data-v-113fc619]{padding:50px 0 50px 24px}.seat-details .seat-list div[data-v-113fc619]{display:flex;flex-wrap:wrap}.seat-details .seat-list h3[data-v-113fc619]{margin-bottom:0}.seat-details .seat-list p[data-v-113fc619]{margin:35px 45px 0 0}.seat-details .md-title[data-v-113fc619]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-113fc619","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/SubscriptionTheatre.vue
// module id = 421
// module chunks = 0